export default "__VITE_ASSET__f566e8ef__"